export default "__VITE_ASSET__CK_RE69E__"